<template>
  <div class="Sidepane">
    <SanityImage v-if="content.kind === 'image' && content.image"
      :asset="content.image.asset"
      class="image"
    />
    <div v-if="content.kind === 'mixed' && content.mixed"
      class="mixed"
    >
      <PortableText :value="content.mixed" :components="serializerComponents" />
    </div>
  </div>
</template>

<script>
import { markRaw } from 'vue'

import SidepaneMixedImage from './SidepaneMixedImage.vue'

export default {
  props: {
    content: Object,
  },
  data() {
    return {
      serializerComponents: {
        types: {
          image: markRaw(SidepaneMixedImage),
        },
      },
    }
  },
}
</script>

<style scoped>

.Sidepane {
  border-radius: 1.25rem 0 0 1.25rem;
  overflow: hidden;
}

.image, .mixed {
  height: 34rem;
}

.mixed {
  background-color: var(--bg-color-pale-gray);
  display: flex;
  flex-direction: column;
  justify-content: center;
  row-gap: var(--spacing-0);
  padding: var(--spacing-7);
  max-width: 22rem;
}

.mixed:deep(h4) {
  font-weight: 600;
  font-size: var(--font-size-3);
  color: var(--brand-color);
}

.mixed:deep(p) {
  font-weight: 400;
  font-size: var(--font-size-2);
  color: var(--text-color-black);
}
</style>
